<template>
    <v-expand-transition>
        <v-toolbar v-if="totalUnsent > 0" card color="warning subheading" dark>
            <v-layout row align-center justify-right>
                <v-flex grow justify-start>
                    <v-btn light :loading="loading" @click="resendUnsent()">
                        <v-icon>refresh</v-icon>
                        <span class="pl-1">Resend</span>
                    </v-btn>
                </v-flex>
                <v-flex shrink v-for="(item, index) in items" :key="index">
                    <v-chip color="warning darken-1" disabled text-color="white">
                        <v-avatar color="warning darken-2" class="white--text font-weight-bold">{{ item.count }}</v-avatar>
                        <span>{{ item.name }}</span>
                    </v-chip>
                </v-flex>
            </v-layout>
        </v-toolbar>
    </v-expand-transition>
</template>

<script>
import forecastingService from '@/services/forecastingService'

import { mapState, mapActions } from "vuex"

export default {
    components: {

    },
    data(){
        return {
            loading: false
        };
    },
    computed: {
        ...mapState("ForecastingStore", [
            "unsentStatus"
        ]),
        totalUnsent(){
            if(this.unsentStatus == null){
                return 0;
            }
            return this.unsentStatus.forecasts + this.unsentStatus.notes + this.unsentStatus.varieties;
        },
        items(){
            let items = [];

            if(this.unsentStatus == null){
                return items;
            }

            if(this.unsentStatus.forecasts > 0){
                items.push({
                    name: "Forecasts",
                    count: this.unsentStatus.forecasts
                });
            }

            if(this.unsentStatus.notes > 0){
                items.push({
                    name: "Notes",
                    count: this.unsentStatus.notes
                });
            }

            if(this.unsentStatus.varieties > 0){
                items.push({
                    name: "Profiles",
                    count: this.unsentStatus.varieties
                });
            }

            return items;
        }
    },
    methods: {
        ...mapActions("ForecastingStore", [
            "loadUnsentStatus"
        ]),
        async resendUnsent(){
            if(this.loading){
                return;
            }

            this.loading = true;

            try {
                await forecastingService.resendUnsent();
            } catch (err) {
                console.log(err);
            }

            await this.loadUnsentStatus();

            this.loading = false;
        }
    },
    created(){

    }
}
</script>